import React from "react";
import classnames from "classnames";
import {
  PER_TIER_KYC_COPY,
  PER_TIER_KYC_MODE,
  PER_TIER_KYC_STYLE,
} from "./PerTierKyc.constants";

export const KycStatusBadge = ({ mode }) => {
  const isCustom = mode === PER_TIER_KYC_MODE.CUSTOM;
  return (
    <div
      className={classnames(
        "tw-flex tw-py-1 tw-px-2.5 tw-gap-1.5 tw-rounded-[18px] tw-w-fit",
        isCustom
          ? PER_TIER_KYC_STYLE.BADGE_CUSTOM_BG
          : PER_TIER_KYC_STYLE.BADGE_INHERIT_BG
      )}
    >
      <div
        className={classnames(
          "tw-size-1.5 tw-rounded-full tw-flex-none tw-mt-[4px]",
          isCustom
            ? PER_TIER_KYC_STYLE.BADGE_CUSTOM_DOT
            : PER_TIER_KYC_STYLE.BADGE_INHERIT_DOT
        )}
      />
      <div
        className={classnames(
          "tw-flex tw-items-center tw-text-xs tw-leading-[normal] tw-tracking-[0.32px] tw-font-medium tw-whitespace-nowrap",
          isCustom
            ? PER_TIER_KYC_STYLE.BADGE_CUSTOM_TEXT
            : PER_TIER_KYC_STYLE.BADGE_INHERIT_TEXT
        )}
      >
        {isCustom
          ? PER_TIER_KYC_COPY.STATUS_CUSTOM
          : PER_TIER_KYC_COPY.STATUS_INHERIT}
      </div>
    </div>
  );
};
